import { gql, useLazyQuery } from '@apollo/client';
import { IconButton, Text, Tooltip } from '@radix-ui/themes';
import { HardDriveDownload } from 'lucide-react';
import { useEffect } from 'react';
import { track } from '../../analytics/track';
import { AnalyticsEvents } from '../../analytics/events';

const GET_DOWNLOAD_LINK = gql`
  query GetFileDownloadLink($fileId: String, $applicationId: String) {
    downloadApplicationDocument(fileId: $fileId, applicationId: $applicationId) {
      url
    }
  }
`;

const DownloadCv = ({
  fileId,
  applicationId,
  className,
}: {
  fileId: string;
  applicationId: string;
  className: string;
}) => {
  const [getFileUrl, { loading, data }] = useLazyQuery(GET_DOWNLOAD_LINK, {
    fetchPolicy: 'network-only',
  });

  const handleDownload = async (id: string) => {
    track(AnalyticsEvents.CV_DOWNLOADED);
    await getFileUrl({ variables: { fileId: id, applicationId } });
  };

  useEffect(() => {
    if (data && data.downloadApplicationDocument) {
      window.open(data.downloadApplicationDocument.url, '_blank');
    }
  }, [data]);

  return (
    <Tooltip content={<Text size="3">Download CV</Text>}>
      <IconButton
        size="3"
        variant="soft"
        color="gray"
        loading={loading}
        className={className}
        onClick={() => handleDownload(fileId)}
        data-ph-capture-attribute-region="cv_download"
      >
        <HardDriveDownload size={20} />
      </IconButton>
    </Tooltip>
  );
};
export default DownloadCv;
